import { FC, useRef } from 'react'
import styles from './Pod4ElevateSleep.module.scss'
import { Pod4ElevateSleepProps } from './types'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import gsap from 'gsap'
import { Img } from 'components/basic/Img'
import { Video } from 'components/basic/Video'
import cx from 'classnames'

const ElevationCard = ({ headElevation, img, feetElevation }: { img: string; headElevation: string; feetElevation: string }) => (
	<div className={styles.elevation}>
		<div className={styles.images}>
			<Img
				alt=""
				src={img}
			/>
		</div>
		<div className={styles.angles}>
			<div className={styles.angleTitle}>Head</div>
			<div className={styles.angleTitle}>Feet</div>
			<div className={styles.angleValue}>{`${headElevation}°`}</div>
			<div className={styles.angleValue}>{`${feetElevation}°`}</div>
		</div>
	</div>
)
export const Pod4ElevateSleep: FC<Pod4ElevateSleepProps> = (props) => {
	const {} = props
	const bannerContainerRef = useRef<HTMLDivElement>(null)
	const accessoriesCardsContainerRef = useRef<HTMLDivElement>(null)
	const elevationCardref = useRef<HTMLDivElement>(null)
	const sleepingCardref = useRef<HTMLDivElement>(null)
	useGSAP(() => {
		gsap.registerPlugin(ScrollTrigger)

		gsap.from(bannerContainerRef.current, {
			ease: 'none',
			clipPath: 'inset(6.25% round 25px)',
			scrollTrigger: {
				trigger: bannerContainerRef.current,
				endTrigger: accessoriesCardsContainerRef.current,
				start: 'top center',
				end: '+=300px',
				scrub: true,
				//	pin:true
				// markers: true,
				// invalidateOnRefresh: true,
			},
		})

		gsap.from(elevationCardref.current, {
			ease: 'power1.out',
			opacity: '0',
			duration: 0.75,
			paddingTop: '8rem',
			scrollTrigger: {
				trigger: bannerContainerRef.current,
				start: 'top 40%',
				toggleActions: 'play none none reverse',
				// markers: true,
				// invalidateOnRefresh: true,
			},
		})
		gsap.from(sleepingCardref.current, {
			opacity: '0',
			duration: 0.75,
			ease: 'power1.out',
			paddingTop: '8rem',
			scrollTrigger: {
				trigger: accessoriesCardsContainerRef.current,
				start: 'top 40%',
				toggleActions: 'play none none reverse',

				onEnter: () => {
					const videoChildren = accessoriesCardsContainerRef.current.querySelectorAll('video')
					videoChildren.forEach((video) => {
						video.play()
					})
				},
				// invalidateOnRefresh: true,

				// markers: true,
			},
		})
		// gsap.from(bannerContainerRef.current, {
		// 	ease: 'none',
		// 	clipPath: 'inset(6.25% round 25px)',
		// 	scrollTrigger: {
		// 		trigger: bannerContainerRef.current,
		// 		endTrigger: accessoriesCardsContainerRef.current,
		// 		start: 'top top',
		// 		end: '+=300px',
		// 		scrub: true,
		// 	},
		// })
	})
	return (
		<div className={styles.container}>
			<div
				className={styles.videoContainer}
				ref={bannerContainerRef}
			>
				<Video
					src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/pod4_Elevate_1_comp.mp4'}
					className={styles.video}
					caption={''}
				/>
				<Video
					src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/eightsleep_mob_elevate1_comp.mp4'}
					className={cx(styles.video, styles.videoMob)}
					caption={''}
				/>
				<div
					className={styles.floatingInfo}
					ref={elevationCardref}
				>
					<div className={styles.eyebrow}>Reading position</div>
					<div className={styles.title}>No more stacking pillows</div>
					<div className={styles.text}>Lounge upright so you can comfortably read in bed. Enjoy your favorite book while unwinding at the perfect elevation before bed.</div>
					<ElevationCard
						img="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/relaxing_elevation_opaque.png"
						headElevation={'30'}
						feetElevation={'15'}
					/>
				</div>
			</div>
			<div
				className={styles.videoContainer}
				ref={accessoriesCardsContainerRef}
			>
				<Video
					src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/sleeping_mode_desktop_1641_comp.mp4'}
					className={styles.video}
					caption={''}
					noLoop
					autoplay={false}
				/>
				<Video
					src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/sleeping_mode_mobile_1642_comp.mp4'}
					className={cx(styles.video, styles.videoMob)}
					caption={''}
					noLoop
					autoplay={false}
				/>
				<div
					className={styles.floatingInfo}
					ref={sleepingCardref}
				>
					<div className={styles.eyebrow}>Sleeping position</div>
					<div className={styles.title}>Float into deep sleep</div>
					<div className={styles.text}>This expertly-designed position evenly distributes pressure across your body to reduce back pain during sleep with a slight elevation of the head and feet.</div>
					<ElevationCard
						img="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/sleeping_elevation_opaque.png"
						headElevation={'5'}
						feetElevation={'5'}
					/>
				</div>
			</div>
		</div>
	)
}
